import { Box, Paper, Typography } from "@mui/material";
import React from "react";

import { ActivityNote } from "../sharedTypes";

interface ActivityItemProps {
  activity: ActivityNote;
}

const ActivityItem: React.FC<ActivityItemProps> = ({ activity }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        bgcolor: "background.default",
        borderRadius: 1,
        borderLeft: "4px solid",
        borderColor:
          activity.type === "email"
            ? "info.main"
            : activity.type === "call"
            ? "warning.main"
            : "success.main",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="subtitle2">{activity.title}</Typography>
        <Typography variant="caption" color="text.secondary"></Typography>
      </Box>
      <Typography variant="body2" color="text.secondary">
        {activity.description}
      </Typography>
      {activity.user_name && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
          {activity.user_name} -
        </Typography>
      )}
      {activity.created_at && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
          Creato in data: {new Date(activity.created_at).toLocaleDateString()}{" "}
          {new Date(activity.created_at).toLocaleTimeString()}
        </Typography>
      )}
    </Paper>
  );
};

export default ActivityItem;
